// extracted by mini-css-extract-plugin
export default {"s1":"GreyStuff_s1__ztCdU","s2":"GreyStuff_s2__PmjKp","s3":"GreyStuff_s3__6Z5kS"};